const generateDropdownItem = (
  id: string,
  label: string,
  customIconName: string,
  separator: boolean = false,
  additionalOptions: object = {}
) => {
  return {
    id,
    label,
    customIconName,
    separator,
    ...(Object.keys(additionalOptions).length !== 0 && {
      ...additionalOptions,
    }),
  };
};

export default generateDropdownItem;
